module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.06.c-12d9f291c32f507832a5c7c9e359ca0f.svg";